// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__J1Rcr","cover":"card_cover__hbm_l","author_image":"card_author_image__v1PIz"};